module.exports = __webpack_public_path__ + "static/media/inventory-3.d0dd15f1.svg";